<template>
  <div>
    <div id="container">
      <div v-if="editable" id="toolbar">
        <div class="toolbar-section">
          <button v-if="!hide.bold" class="wysiwyg-button" :class="isBold ? 'wysiwyg-button-active' : ''" @click.prevent="bold">
            <i class="fa fa-bold"></i>
          </button>
          <button v-if="!hide.italic" class="wysiwyg-button" :class="isItalic ? 'wysiwyg-button-active' : ''" @click.prevent="italize">
            <i class="fa fa-italic"></i>
          </button>
          <button v-if="!hide.underline" class="wysiwyg-button" :class="isUnderlined ? 'wysiwyg-button-active' : ''" @click.prevent="underline">
            <i class="fa fa-underline"></i>
          </button>
          <button v-if="!hide.strikethrough" class="wysiwyg-button" :class="isStrikedThrough ? 'wysiwyg-button-active' : ''" @click.prevent="strikeThrough">
            <i class="fa fa-strikethrough"></i>
          </button>
          <button v-if="!hide.heading" class="wysiwyg-button" :class="isHeading ? 'wysiwyg-button-active' : ''" @click.prevent="showHeadings">
            <i class="fa fa-header"></i>
          </button>
        </div>
        <div class="toolbar-section">
          <button v-if="!hide.alignLeft" class="wysiwyg-button" :class="isAlignedLeft ? 'wysiwyg-button-active' : ''" @click.prevent="alignLeft">
            <i class="fa fa-align-left"></i>
          </button>
          <button v-if="!hide.alignCenter" class="wysiwyg-button" :class="isAlignedCenter ? 'wysiwyg-button-active' : ''" @click.prevent="alignCenter">
            <i class="fa fa-align-center"></i>
          </button>
          <button v-if="!hide.alignRight" class="wysiwyg-button" :class="isAlignedRight ? 'wysiwyg-button-active' : ''" @click.prevent="alignRight">
            <i class="fa fa-align-right"></i>
          </button>
          <button v-if="!hide.ol" class="wysiwyg-button" @click.prevent="orderedList">
            <i class="fa fa-list-ol"></i>
          </button>
          <button v-if="!hide.ul" class="wysiwyg-button" @click.prevent="insertUnorderedList">
            <i class="fa fa-list"></i>
          </button>
        </div>
        <div class="toolbar-section">
          <!-- <button v-if="!hide.url" class="wysiwyg-button" :class="showLinkForm ? 'wysiwyg-button-active' : ''" @click.prevent="showLinkOptions">
            <b style="font-size: 10px;">URL</b>
          </button> -->
          <button v-if="!hide.table" class="wysiwyg-button" :class="showTableForm ? 'wysiwyg-button-active' : ''" @click.prevent="showTableOptions">
            <i class="fa fa-table"></i>
          </button>
          <!-- <button v-if="!hide.indent" class="wysiwyg-button" @click.prevent="indent">
            <i class="fa fa-circle-o"></i>
          </button>
          <button v-if="!hide.outdent" class="wysiwyg-button" @click.prevent="outdent">
            <i class="fa fa-circle-o"></i>
          </button> -->
          <button v-if="!hide.clearfmt" class="wysiwyg-button" @click.prevent="clearfmt">
            <i class="fa fa-eraser"></i>
          </button>
        </div>
      </div>
      <!-- OPTIONS -->
      <div v-if="showHeadingOptions" id="toolbar-options">
        <button class="wysiwyg-button wysiwyg-button-loop" v-for="size in hSizes" :key="size" @click.prevent="heading(size)">{{size}}</button>
      </div>
      <!-- <div v-if="showLinkForm" id="toolbar-options">
        <form @submit.prevent="createLink">
          <input v-model="linkText" type="text" placeholder="Link Text" required/>
          <input v-model="linkURL" type="text" placeholder="URL" required/>
          <button type="submit" class="wysiwyg-button">Insert</button>
          <button @click.prevent="linkText = ''; linkURL = ''" class="wysiwyg-button">Clear</button>
        </form>
      </div> -->
      <div v-if="showTableForm" id="toolbar-options">
        <form @submit.prevent="createTable">
          <input v-model="rows" min="0" type="number" placeholder="Rows" required/>
          <input v-model="cols" min="0" type="number" placeholder="Columns" required/>
          <button type="submit" class="wysiwyg-button">Insert</button>
          <button @click.prevent="rows = null; cols = null" class="wysiwyg-button">Clear</button>
        </form>
        <div class="hoverTableCont">
          <div class="hoverTable" @mouseleave="changeSelectedCell(0, 0)">
            <div class="hoverRow" v-for="(row, key) in 12" :key="key">
              <div
                v-for="(col, key) in 12" 
                :class="['hoverCell', { 'highlightCell': isHighlighted(row, col)}]" 
                @mouseover="changeSelectedCell(row, col)" 
                @click="setupCreateTable"
                :key="key"
              ></div>
            </div>
          </div>
          <br>
          <div id="tableDimmensions">
            <em v-if="noSelectedCell">Select boxes above</em>
            <em v-else>{{ this.selectedCell.cols }} x {{ this.selectedCell.rows }}</em>
          </div>
        </div>
      </div>
      <div id="body">
        <div id="editor" :contenteditable="editable"></div>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  props: {
    value: {
      type: String
    },
    hide: {
      type: Object,
      default: () => ({})
    },
    editable: {
      type: Boolean,
      default: false
    },
    height: {
      type: [Number, String],
      default: 400
    }
  },
  data () {
    return {
      isBold: false,
      isItalic: false,
      isUnderlined: false,
      isStrikedThrough: false,
      isHeading: false,
      isAlignedLeft: false,
      isAlignedCenter: false,
      isAlignedRight: false,
      showToolbarOptions: false,
      showHeadingOptions: false,
      // showLinkForm: false,
      linkText: '',
      linkURL: '',
      showTableForm: false,
      rows: null,
      cols: null,
      selectedCell: {
        rows: 0,
        cols: 0
      },
      caratSelection: null,
      savedPosition: null
    };
  },
  computed: {
    hSizes () {
      let sizes = [];
      for(let x = 1; x <= 6; x++) {
        sizes.push(`H${x}`);
      }
      sizes.push('Clear');
      return sizes;
    },
    noSelectedCell () {
      return this.selectedCell.rows === 0 && this.selectedCell.cols === 0;
    },
  },
  watch: {
    value: {
      handler (val) {
        if (val) {
          setTimeout(() => {
            if (!document.getElementById('editor').innerHTML) {
              document.getElementById('editor').innerHTML = val;
            }
          }, 100);
        }
      },
      immediate: true
    }
  },
  methods: {
    bold () {
      this.isBold = !this.isBold;
      this.exec('bold');
    },
    italize () {
      this.isItalic = !this.isItalic;
      this.exec('italic');
    },
    underline () {
      this.isUnderlined = !this.isUnderlined;
      this.exec('underline');
    },
    strikeThrough () {
      this.isStrikedThrough = !this.isStrikedThrough;
      this.exec('strikeThrough');
    },
    heading (size) {
      this.exec('formatBlock', false, size === 'Clear' ? 'p' : size);
    },
    showHeadings () {
      this.isHeading = !this.isHeading;
      this.showHeadingOptions = !this.showHeadingOptions;
    },
    alignLeft () {
      this.isAlignedLeft = !this.isAlignedLeft;
      this.exec('justifyLeft');
    },
    alignCenter () {
      this.isAlignedCenter = !this.isAlignedCenter;
      this.exec('justifyCenter');
    },
    alignRight () {
      this.isAlignedRight = !this.isAlignedRight;
      this.exec('justifyRight');
    },
    // showLinkOptions () {
    //   this.showLinkForm = !this.showLinkForm;
    // },
    // createLink () {
    //   let selected = document.getSelection();
    //   if (selected.anchorOffset === selected.extentOffset) 
    //     selected = this.linkText;
    //   this.exec('insertHTML', false, `<a href='${this.linkURL}'>${selected}</a>`);
    // },
    orderedList () {
      this.exec('insertOrderedList');
    },
    insertUnorderedList () {
      this.exec('insertUnorderedList');
    },
    showTableOptions () {
      if (!this.showTableForm) {
        this.caratSelection = document.getSelection();
        this.savedPosition = [ this.caratSelection.focusNode, this.caratSelection.focusOffset ];
      }
      this.showTableForm = !this.showTableForm;
    },
    generateTable (rows, cols) {
      let text = '';
      for (let row = 1; row <= rows; row++) {
        text += `<tr>`;
        for (let col = 1; col <= cols; col++) {
          text += `<td style="border: 1px solid lightgrey; padding: 2px;"></td>`;
        }
        text += `</tr>`;
      }
      return text;
    },
    setupCreateTable () {
      this.rows = this.selectedCell.rows;
      this.cols = this.selectedCell.cols;
      this.createTable();
    },
    createTable () {
      document.getElementById('editor').focus();
      this.caratSelection.collapse(this.savedPosition[0], this.savedPosition[1]);
      let table = `
        <table width="100%" style="border-collapse: collapse; border: 1px solid lightgrey;">
          <tbody>
            ${this.generateTable(this.rows, this.cols)}
          </tbody>
        </table>
      `;

      this.exec('insertHTML', false, table);
      this.showTableForm = false;
      this.caratSelection = null;
      this.savedPosition = null;
    },
    indent () {
      this.exec('indent');
    },
    outdent () {
      this.exec('outdent');
    },
    clearfmt(){
      this.exec('removeFormat');
    },
    changeSelectedCell (row, col) {
      this.selectedCell.rows = row;
      this.selectedCell.cols = col;
    },
    isHighlighted (row, col) {
      if (this.noSelectedCell ) return false;
      if (row <= this.selectedCell.rows && col <= this.selectedCell.cols ) return true;
      return false;
    },
    exec (...args) {
      document.execCommand(...args);
    },
    getValue () {
      this.$emit('input', document.getElementById('editor').innerHTML);
    }
  },
  mounted () {
    let that = this;
    this.$nextTick(() => {
      document.getElementById('editor').addEventListener('input', function() {
        that.getValue();
      }, false);
    });
  },
}
</script>

<style scoped>
input {
  margin: 4px;
  padding: 2px;
  border: 1px solid lightgrey;
}

input:focus {
  outline: none;
}

#container {
  border: 1px solid #ced4da;
  border-radius: .25rem;  
  min-height: 250px;
}

#body {
  display: inline-block;
  width: 100%;  
}

#editor {
  font-family: inherit;
  color: inherit;
  line-height: 1.33;
  padding: 12px 10px 16px 10px;
  max-height: 700px;
  min-height: 200px;
  overflow: auto;
}

#toolbar {
  min-height: 33px;
  border-bottom: 1px solid lightgrey;
  background-color: rgb(247, 247, 247);
  color: #6c757d;
  overflow: hidden;
}

#toolbar-options {
  min-height: 33px;
  border-bottom: 1px solid lightgrey;
  overflow: hidden;
}

#editor:focus {
  outline: none;
}

.toolbar-section {
  float: left;
  border-right: 1px solid lightgrey;
  background-color: rgb(247, 247, 247);
}

.wysiwyg-button {
  height: 32px;
  min-width: 32px;
  background-color: transparent;
  text-align: center;
  padding: 2px;
  border-style: none;
  color: dimgray;
  font-size: 13px;
}

.wysiwyg-button:hover {
  background-color: lightblue;
}

/* .wysiwyg-button-active {
  background-color: lightblue;
} */

.wysiwyg-button-loop {
  margin-right: 4px;
}
.hoverTableCont {
    width: 230px;
    margin-right: 30px;
    float: left;
    padding: 15px 0px 0px 15px;
}
.hoverCell {
  border: 1px solid #aaa;
	height: 16px;
	width: 16px;
	margin: 0 1px 1px 0;
	float: left;
	cursor: pointer;
}
.hoverCell:hover {
	background-color: #4b67a1 !important;
}
.hoverRow {
    display: block;
    clear: both;
}
.highlightCell {
  background-color: #d1e0ff;
}
</style>


// WEBPACK FOOTER //
// src/McWysiwyg.vue